import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getActiveLanguage, Language } from '@teamfoster/sdk/language-ngrx';
import { from, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Collection, Filter } from '../models';
import { GraphQLService } from './graph-ql.service';
import { catalogProductResult } from './product-queries';
@Injectable({
  providedIn: 'root',
})
export class CollectionsService extends GraphQLService {
  // language$!: Observable<string>;

  constructor() {
    super();
    // this.language$ = this.store.select(getActiveLanguage);
  }

  getCollections(language?: string) {
    const query = this.client.query(`@inContext(language: ${language})`, (root: any) => {
      root.addConnection('collections', { args: { first: 250 } }, (collections: any) => {
        collections.add('id');
        collections.add('title');
        collections.add('description');
        collections.add('updatedAt');
        collections.add('handle');
        collections.add('image', (image: any) => {
          image.add('url', { args: { transform: { maxHeight: 600, crop: this.client.enum('CENTER') } } });
          image.add('id');
          image.add('altText');
        });
      });
    });

    return from(this.client.send(query)).pipe(
      map((a: any) => {
        return a['data'].collections.edges.map((e: any) => e.node);
      })
    ) as Observable<any>;
    // return from(this.client.send(query)).pipe(map(({ data, model }) => data.collections.edges.map(e => e.node)));
  }

  getCollectionByHandle(handle: string, language?: string) {
    const query = this.client.query(`@inContext(language: ${language})`, (root: any) => {
      root.add('shop', (shop: any) => {
        shop.add('name');
      });
      root.add('collection', { args: { handle } }, (collection: any) => {
        collection.add('id');
        collection.add('title');
        collection.add('description');
        collection.add('updatedAt');
        collection.add('handle');
        collection.add(
          'metafields',
          {
            args: {
              identifiers: [
                { namespace: 'custom', key: 'has_header' },
                { namespace: 'custom', key: 'has_filters' },
                { namespace: 'custom', key: 'header_image' },
                { namespace: 'custom', key: 'main_category' },
                { namespace: 'custom', key: 'collection_description_rich' },
              ],
            },
          },
          (metafields: any) => {
            metafields.add('key');
            metafields.add('value');
            metafields.add('type');
          }
        );
        collection.add(
          'metafield',
          {
            args: { namespace: 'custom', key: 'header_image' },
          },
          (metafield: any) => {
            metafield.add('key');
            metafield.add('value');
            metafield.add('type');
            metafield.add('reference', (ref: any) => {
              ref.addInlineFragmentOn('MediaImage', (refImg: any) => {
                refImg.add('id');
                refImg.add('image', (refImgObj: any) => {
                  refImgObj.add('src');
                  refImgObj.add('id');
                  refImgObj.add('altText');
                  //refImgObj.add('url', { args: { transform: { crop: this.client.enum('CENTER'), maxHeight: 1440, maxWidth: 4320 } } });

                  refImgObj.add('url', {
                    args: {
                      transform: {
                        crop: this.client.enum('CENTER'),
                        preferredContentType: this.client.enum('WEBP'),
                        maxHeight: 1440,
                        maxWidth: 4320,
                      },
                    },
                    alias: 'w_4320',
                  });

                  refImgObj.add('url', {
                    args: {
                      transform: {
                        crop: this.client.enum('CENTER'),
                        preferredContentType: this.client.enum('WEBP'),
                        maxHeight: 1440,
                        maxWidth: 1920,
                      },
                    },
                    alias: 'w_1920',
                  });

                  refImgObj.add('url', {
                    args: {
                      transform: {
                        crop: this.client.enum('CENTER'),
                        preferredContentType: this.client.enum('WEBP'),
                        maxHeight: 1440,
                        maxWidth: 1200,
                      },
                    },
                    alias: 'w_1200',
                  });

                  refImgObj.add('url', {
                    args: {
                      transform: { crop: this.client.enum('CENTER'), preferredContentType: this.client.enum('WEBP'), maxWidth: 800 },
                    },
                    alias: 'w_800',
                  });
                  refImgObj.add('url', {
                    args: {
                      transform: { crop: this.client.enum('CENTER'), preferredContentType: this.client.enum('WEBP'), maxWidth: 500 },
                    },
                    alias: 'w_500',
                  });
                  refImgObj.add('url', {
                    args: {
                      transform: { crop: this.client.enum('CENTER'), preferredContentType: this.client.enum('WEBP'), maxWidth: 350 },
                    },
                    alias: 'w_350',
                  });
                  refImgObj.add('url', {
                    args: {
                      transform: { crop: this.client.enum('CENTER'), preferredContentType: this.client.enum('WEBP'), maxWidth: 200 },
                    },
                    alias: 'w_200',
                  });
                });
              });
            });
          }
        );

        collection.add('image', (image: any) => {
          image.add('url', { args: { transform: { maxHeight: 1600, crop: this.client.enum('CENTER') } } });
          image.add('id');
          image.add('altText');
        });
        collection.add('seo', (seo: any) => {
          seo.add('title');
          seo.add('description');
        });
        collection.addField('products', { args: { first: 1 } }, (products: any) => {
          catalogProductResult(products, this.client);
        });
      });
    });
    return from(this.client.send(query)).pipe(
      tap(console.log),
      map((a: any) => {
        if (!a['data'].collection) {
          return null;
        }

        let { products, ...collection } = a['data'].collection;
        let filters: Filter[] = a['data'].collection.products.filters;
        filters = filters.map(a => ({ ...a, values: a.values.map(b => ({ ...b, input: JSON.parse(b.input) })) }));

        return { ...collection, filters };
      })
    ) as Observable<any>;
    // return from(this.client.send(query)).pipe(map(({ data, model }) => data.collectionByHandle));
  }
}
